const templateUrl = require('./../views/partials/stripeform.html');

function StripeFormController($sce, $state, Program, Cause, Payment2_transaction, ReferrerService, ConfigEnvironment) {
  "ngInject";

  this.$onInit = () => {

    console.log('__stripeForm__');
    
    console.log(this);

    const registration = JSON.parse(this.registration);

    const programFilter = {
      "cause_id": registration.selected_cause.id,
      "referred_by": ReferrerService.getReferredBy()
    };

    Cause.getPrograms(programFilter).$promise.then((programs) => {
      this.programs = programs.programs;
    }).catch(function(err) {
      console.error("Unable to retrieve programs", err);
    });

    this.payment_checkout_url = false;

    this.proceedToCheckout = function() {
      if (this.payment_checkout_url) {
        window.location.href = this.payment_checkout_url;
      }
    }

    this.selectProgram = () => {
      
      Program.findOne({
        "filter": {
          "where": {"id": this.program_id}
        }
      }).$promise.then((program) => {
        this.selectedProgram = program;  

        const rbVars = {};

        if(programFilter.referred_by && programFilter.referred_by.entity_id) {

          rbVars.rb_entity_id = parseInt(programFilter.referred_by.entity_id);
        
          if(programFilter.referred_by.entity_type) {
            rbVars.rb_entity_type = programFilter.referred_by.entity_type;
          }

          if(programFilter.referred_by.subentity_id) {
            rbVars.rb_subentity_id = parseInt(programFilter.referred_by.subentity_id);
          }
        
          if(programFilter.referred_by.referrer_id) {
            rbVars.rb_referrer_id = parseInt(programFilter.referred_by.referrer_id);
          }
        }

        Payment2_transaction.createSession({
          subscriber_id: registration.subscriber_id,
          selected_cause_id: registration.selected_cause.id,
          program_id: parseInt(this.program_id),
          referred_by: rbVars
        }).$promise.then(({payment_session}) => {
          if (payment_session.code === 303) { 
            this.payment_checkout_url = payment_session.url;
          }
          else {
            this.payment_checkout_url = false;
          }
        }).catch(err => {
          this.payment_checkout_url = false;
        });

      }).catch(function(err) {
        console.error(err.message);
        return false;
      });
    }
  }
}


const component = {
  bindings: {
    registration: '@'
  },
  controller: StripeFormController,
  templateUrl,
  restrict: 'E'
}

export default component;



// WEBPACK FOOTER //
// ./js/containers/users/components/stripeform.js